  import React, { useState, useEffect } from 'react';
  import {
    LayoutDashboard,
    User,
    MapPin,
    GraduationCap,
    ChevronUp,
    ChevronDown,
    Briefcase,
    FileText,
    Menu,
  } from 'lucide-react';
  import { Outlet, useNavigate, useLocation } from 'react-router-dom';
  import TopNavbar from '../../top-navbar/TopNav';
  import '../../top-navbar/topnavBar.css';

  const Navbar = () => {
    const [showEmployeeSubMenu, setShowEmployeeSubMenu] = useState(false);
    const [isLocked, setIsLocked] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const sidebarWidth = '12rem';
    const shouldShowSidebar = isLocked || isHovering;

    useEffect(() => {
      const handleMouseMove = (e) => {
        if (isLocked) return;
        if (e.clientX <= 20) {
          setIsHovering(true);
        } else if (!e.target.closest('.admin-dashboard-sidebar')) {
          setIsHovering(false);
        }
      };
      window.addEventListener('mousemove', handleMouseMove);
      return () => window.removeEventListener('mousemove', handleMouseMove);
    }, [isLocked]);

    const getTitleForPage = () => {
      const path = location.pathname;
      const state = location.state;

      if (state?.heading) return state.heading; 
      if (path.includes('dashboard')) return 'Dashboard';
      if (path.includes('view-profile')) return 'View Profile';
      if (path.includes('clients')) return 'Client List';
      if (path.includes('reports')) return 'Candidate Report'; 
      if (path.includes('add-employee')) return 'Add New Employee';
      if (path.includes('inactive-employee')) return 'Inactive Employees';
      if (path.includes('active-employee')) return 'Active Employees';
      if (path.includes('employee') && path.includes('candidates')) return 'Assigned Candidates';
      if (path.includes('candidates')) return 'Client Candidates';
      if (path.includes('candidate-details')) return 'Candidate Details';
      if (path.includes('service-down')) return 'Service Down';
      return 'Dashboard';
    };

    return (
      <div className="admin-dashboard-container">
        <TopNavbar />

        <aside
          className={`admin-dashboard-sidebar ${shouldShowSidebar ? 'visible' : 'hidden'}`}
          style={{ width: sidebarWidth }}
          onMouseLeave={() => {
            if (!isLocked) setIsHovering(false);
          }}
        >
          <div
            className={`admin-sidebar-close-icon ${isLocked ? 'active' : ''}`}
            title={isLocked ? 'Click to Collapse' : 'Click to Lock Sidebar'}
            onClick={() => {
              const newLock = !isLocked;
              setIsLocked(newLock);
              if (!newLock) setIsHovering(false);
            }}
          >
            <Menu className="admin-menu-icon-hover" />
          </div>


          <nav>
            <ul className="admin-sidebar-menu">
              <li
                className={`admin-sidebar-menu-item ${location.pathname === '/admin' ? 'active' : ''}`}
                onClick={() => navigate('/admin')}
              >
                <LayoutDashboard className="admin-sidebar-icon" />
                <span>Dashboard</span>
              </li>
              <div className="admin-sidebar-divider"></div>

              <li
                className={`admin-sidebar-menu-item ${location.pathname === '/admin/view-profile' ? 'active' : ''}`}
                onClick={() => navigate('/admin/view-profile')}
              >
                <User className="admin-sidebar-icon" />
                <span>View Profile</span>
              </li>
              <div className="admin-sidebar-divider"></div>

              <li
                className={`admin-sidebar-menu-item ${location.pathname === '/admin/clients' ? 'active' : ''}`}
                onClick={() => navigate('/admin/clients')}
              >
                <User className="admin-sidebar-icon" />
                <span>Client List</span>
              </li>
              <div className="admin-sidebar-divider"></div>

              <li
                className={`admin-sidebar-menu-item ${location.pathname === '/admin/add-employee' ? 'active' : ''}`}
                onClick={() => navigate('/admin/add-employee')}
              >
                <MapPin className="admin-sidebar-icon" />
                <span>Add Employee</span>
              </li>
              <div className="admin-sidebar-divider"></div>

              <li
                onClick={() => setShowEmployeeSubMenu(!showEmployeeSubMenu)}
                className="admin-sidebar-menu-item admin-sidebar-item-toggle"
              >
                <div className="flex items-center">
                  <GraduationCap className="admin-sidebar-icon" />
                  <span>Employee List</span>
                </div>
                {showEmployeeSubMenu ? <ChevronUp /> : <ChevronDown />}
              </li>

              {showEmployeeSubMenu && (
                <ul className="admin-sidebar-submenu">
                  <li
                    className={`admin-sidebar-submenu-item ${
                      location.pathname === '/admin/active-employee' ? 'active' : ''
                    }`}
                    onClick={() => navigate('/admin/active-employee')}
                  >
                    <Briefcase className="admin-sidebar-icon sub-icon" />
                    <span>Active Employees</span>
                  </li>
                  <li
                    className={`admin-sidebar-submenu-item ${
                      location.pathname === '/admin/inactive-employee' ? 'active' : ''
                    }`}
                    onClick={() => navigate('/admin/inactive-employee')}
                  >
                    <FileText className="admin-sidebar-icon sub-icon" />
                    <span>Inactive Employee</span>
                  </li>
                </ul>
              )}
            </ul>
          </nav>
        </aside>

        <main
          className="admin-dashboard-main"
          style={{ marginLeft: shouldShowSidebar ? sidebarWidth : '0', transition: 'margin-left 0.3s ease' }}
        >
          <div className="admin-dashboard-header-row">
            <div className="admin-dashboard-title-bar">
              <h2 className="admin-page-title">{getTitleForPage()}</h2>
            </div>
          </div>

          <div className="admin-dashboard-page-content">
            <Outlet />
          </div>
        </main>
      </div>
    );
  };

  export default Navbar;
